// Routes kept out of the sidebar (they are also in DEPRECATED_ROUTES) but still
// reachable from a page action. Access is granted only if the backend menu
// actually contained the route for this user (module + restrictions).
export const HIDDEN_BUT_ROUTABLE_ROUTES = [
  '/ManageAccounts/SharedAccountAccess',
];

// use deprecated routes when needing to always remove a route from the menu
export const DEPRECATED_ROUTES = [
  '/ManageAccounts',
  '/ManageAccounts/SharedAccountAccess',
  '/Insights',
  '/Insights/Opportunities',
  '/Insights/Risks',
  '/Insights/ToDoList',
  '/Tools/Documents',
  '/Reports/Business',
  '/Reports/Scheduled',
];

export interface RouteRemap {
  from: string;
  to: string;
}

/**
 * use route remappings when mapping configurable modules (ie, if a route is in the user's menu data, they have that module enabled;
 * this is used to remap the route for that enabled module to the corresponding new route in the new UI)
 */
export const ROUTE_REMAPPINGS: RouteRemap[] = [
  { from: '/Tools/Team', to: '/Team' },
  { from: '/Setup/Overview', to: '/Configuration' },
  { from: '/Setup', to: '/Configuration' },
  { from: '/BusinessIntelligence', to: '/Analytics' },
  { from: '/Setup/Configuration', to: '/Configuration/ClientPortal' },
  { from: '/Setup/Configuration/Legal', to: '/Configuration/Legal' },
  {
    from: '/Setup/Configuration/Legal/Disclaimer',
    to: '/Configuration/Legal/Disclaimer',
  },
  { from: '/Setup/Integrations', to: '/Configuration/Integrations' },
  // Legacy Setup > Managed Accounts → new-UI Configuration > Managed Accounts.
  // Leaf 'managedaccounts' matches the curated sidebar item.
  { from: '/Setup/Accounts', to: '/Configuration/ManagedAccounts' },
  { from: '/Setup/TeamMembers', to: '/Configuration/TeamMembers' },
  { from: '/Advisor/Team', to: '/Configuration/TeamMembers' },
  { from: '/Insights/Overview', to: '/Analytics/Insights' },
  { from: '/Tools/Documents2', to: '/Documents/DocumentVault' },
  { from: '/Tools/Document2', to: '/Documents/DocumentVault' },
  { from: '/Reports', to: '/Documents/Reports' },
  { from: '/CD/Documents2', to: '/Documents/DocumentVault' },
  { from: '/CD/Document2', to: '/Documents/DocumentVault' },
  { from: '/CD/Notes', to: '/Documents/Notes' },
];
